var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":80,"width":7,"indeterminate":"","color":"primary"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }